var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { RestrictedDateDomain, RestrictedDateTransferType, } from '@ally/data-types-restricted-dates';
function getHolidays(restrictedDates) {
    return restrictedDates.reduce(function (acc, restrictedDate) {
        var _a, _b, _c, _d, _e;
        var domain = restrictedDate.domain, observed = restrictedDate.observed, transferType = restrictedDate.transferType, name = restrictedDate.name;
        // Generate map key (assumes sever format includes YYYY-MM-DD)
        var datePattern = /\d{4}-\d{2}-\d{2}/;
        var _f = __read(observed.match(datePattern), 1), dateString = _f[0];
        // Filter out allowed days (like Tax Day)
        if (transferType === RestrictedDateTransferType.Allowed) {
            if (name === 'Tax Day') {
                return __assign(__assign({}, acc), { taxDay: __assign(__assign({}, acc.taxDay), (_a = {}, _a[dateString.slice(0, 4)] = dateString, _a)) });
            }
            return acc;
        }
        switch (domain) {
            case RestrictedDateDomain.Federal: {
                return __assign(__assign({}, acc), { federal: __assign(__assign({}, acc.federal), (_b = {}, _b[dateString] = restrictedDate, _b)) });
            }
            case RestrictedDateDomain.Invest: {
                return __assign(__assign({}, acc), { nyse: __assign(__assign({}, acc.nyse), (_c = {}, _c[dateString] = restrictedDate, _c)) });
            }
            case RestrictedDateDomain.Both: {
                return __assign(__assign({}, acc), { federal: __assign(__assign({}, acc.federal), (_d = {}, _d[dateString] = restrictedDate, _d)), nyse: __assign(__assign({}, acc.nyse), (_e = {}, _e[dateString] = restrictedDate, _e)) });
            }
            // skip wires holidays
            case RestrictedDateDomain.Wires:
            default:
                return acc;
        }
    }, {
        federal: {},
        nyse: {},
        taxDay: {},
    });
}
export default getHolidays;
//# sourceMappingURL=getHolidays.js.map